module.exports = __webpack_public_path__ + "img/short-term-dormant-percentage.b65b689f.png";